import React from 'react';
import { Translation } from 'react-i18next';
import { Typography, Input } from 'antd';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';

const { Title } = Typography;

const LearningAdminHeaderScreen = ({ ...props }) => {
  return (
    <Translation>
      {(t) => (
        <>
          <Title level={2} className='learning-title'>
            {t('learning_admin_title')}
          </Title>
          <Input
            style={{
              width: '20%',
            }}
            placeholder={t('learning_admin_header_search')}
            allowClear
          />
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminHeaderScreen);

Logger.log('silly', `LearningAdminHeaderScreen loaded.`);
